import { useState } from "react";
import {Form, Button} from "react-bootstrap";
import Eye from '../../img/eye.svg';
import EyeSlash from '../../img/eye-slash.svg';

const PassowrdForm =({label, value, event}) => {

    const [passwordShown, setPasswordShown] = useState(false);

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    return (
        <Form.Group className="mb-1" controlId="password">
            <Form.Label>{label}*</Form.Label>
            <div className={'position-relative'}>
                <Form.Control
                    type={passwordShown ? "text" : "password"}
                    placeholder="Scrivi qui..."
                    value={value}
                    onChange={(value) => event(value.target.value)}
                />
                <Button onClick={togglePassword} className={'btn-password-toggle'} variant={'link'}>
                    {
                        passwordShown ?  <img src={EyeSlash} className={'icon-password'} alt={''} /> : <img src={Eye} className={'icon-password'} alt={''} />
                    }
                </Button>
            </div>
        </Form.Group>
    );
}
export default PassowrdForm;
